import { LegalPage } from "../components/LegalPage";

const UPDATED = "June 2026";

const INTRO = [
  "These Terms of Service (\"Terms\") govern your access to and use of EAZIKAST, a web and progressive web application for planning and organising precast concrete yards (the \"Service\"), operated by Eazikast (\"Eazikast\", \"we\", \"us\"). By creating an account or using the Service, you agree to these Terms.",
];

const SECTIONS = [
  { h: "Acceptance of Terms", p: [
    "By registering for, accessing, or using the Service, you confirm that you have read, understood, and agree to be bound by these Terms and our Privacy Policy. If you are using the Service on behalf of an organisation, you represent that you are authorised to bind that organisation to these Terms.",
  ]},
  { h: "Description of the Service", p: [
    "EAZIKAST helps precast yards plan production by managing casting-table layouts, panel queues, concrete load bookings, shop-drawing imports, and printable schedules. Features may be added, changed, or removed over time.",
  ]},
  { h: "Accounts and Registration", p: [
    "You must provide accurate information when creating an account and keep your login credentials secure. You are responsible for all activity that occurs under your account. Notify us promptly of any unauthorised use.",
  ]},
  { h: "Acceptable Use", p: ["You agree not to:"], list: [
    "Use the Service for any unlawful purpose or in violation of any applicable regulations.",
    "Attempt to gain unauthorised access to the Service, other accounts, or our systems.",
    "Interfere with, disrupt, or place undue load on the Service or its infrastructure.",
    "Reverse engineer, resell, or sublicense the Service without our written permission.",
  ]},
  { h: "Your Content and Data", p: [
    "You retain ownership of the yard data, drawings, and other content you upload or create (\"Your Content\"). You grant us a limited licence to store, process, and display Your Content solely to operate and provide the Service to you.",
    "You are responsible for the accuracy of Your Content and for ensuring you have the rights to upload any drawings or files.",
  ]},
  { h: "Availability and Offline Use", p: [
    "The Service is provided on an \"as available\" basis. We do not guarantee uninterrupted or error-free operation. The Service includes offline functionality that caches data on your device and syncs when a connection is restored; sync is provided on a best-effort basis and you are responsible for verifying that critical data has saved.",
  ]},
  { h: "Disclaimers", p: [
    "The Service is provided \"as is\" without warranties of any kind, whether express or implied. EAZIKAST is a planning aid and does not replace professional engineering judgement, structural certification, or on-site verification. You are solely responsible for production, casting, lifting, and delivery decisions made using the Service.",
  ]},
  { h: "Limitation of Liability", p: [
    "To the maximum extent permitted by law, EAZIKAST and its operators shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits, data, or goodwill arising from your use of the Service.",
  ]},
  { h: "Termination", p: [
    "You may stop using the Service and delete your account at any time. We may suspend or terminate access if you breach these Terms or if required to protect the Service or other users.",
  ]},
  { h: "Changes to These Terms", p: [
    "We may update these Terms from time to time. Material changes will be reflected by updating the \"Last updated\" date above. Continued use of the Service after changes take effect constitutes acceptance of the revised Terms.",
  ]},
  { h: "Governing Law", p: [
    "These Terms are governed by the laws of the jurisdiction in which the Service operator is established, without regard to conflict-of-law principles.",
  ]},
  { h: "Contact", p: [
    "Questions about these Terms can be sent to kanyemacgregor@eazikast.com.",
  ]},
];

export default function Terms() {
  return <LegalPage testid="terms-page" title="Terms of Service" updated={UPDATED} intro={INTRO} sections={SECTIONS} />;
}
